import { all } from "redux-saga/effects";
import {
  addStrAccWatcher,
  addStrBrandSoftwareWatcher,
  addStrDispatchWatcher,
  addStrFollowUpWatcher,
  addStrInfraWatcher,
  addStrOpeningWatcher,
  addStrbrandWatcher,
  deleteItemWatcher,
  storeAddressCreateWatcher,
  storeAddressUpdateWatcher,
  storeAgreementCreateWatcher,
  storeDrugCreateWatcher,
  storeFirmCreateWatcher,
  storeLOICreateWatcher,
  storePaymentCreateWatcher,
  storePersonalCreateWatcher,
  storeTableWatcher,
  strExeGetWatcher,
  strFollowUpGetWatcher,
  storeDrugUpdateWatcher,
  storePartnerCreateWatcher,
  getFofoStoreTypesWatcher,
  getFofoFirmTypesWatcher,
  selfDeclarationTableWatcher,
  selfDeclarationDeleteWatcher,
  selfDeclarationViewWatcher,
} from "../store-saga";

export default function* storeRootSaga() {
  yield all([
    deleteItemWatcher(),
    storeAddressCreateWatcher(),
    storePersonalCreateWatcher(),
    storeFirmCreateWatcher(),
    storePartnerCreateWatcher(),
    storeAgreementCreateWatcher(),
    storePaymentCreateWatcher(),
    storeDrugCreateWatcher(),
    storeLOICreateWatcher(),
    getFofoStoreTypesWatcher(),
    storeAddressUpdateWatcher(),
    storeTableWatcher(),
    addStrInfraWatcher(),
    addStrbrandWatcher(),
    addStrBrandSoftwareWatcher(),
    addStrAccWatcher(),
    addStrDispatchWatcher(),
    addStrOpeningWatcher(),
    addStrFollowUpWatcher(),
    strFollowUpGetWatcher(),
    strExeGetWatcher(),
    storeDrugUpdateWatcher(),
    getFofoFirmTypesWatcher(),
    selfDeclarationTableWatcher(),
    selfDeclarationDeleteWatcher(),
    selfDeclarationViewWatcher(),
  ]);
}
